import { Avatar, Stack, SxProps, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface ITitleImageAndText {
  title: string;
  image: string;
  showImage?: boolean;
  testSx?: SxProps;
  imageSx?: SxProps;
}

export const TitleImageAndText = ({
  title,
  image,
  showImage = true,
  testSx,
  imageSx,
}: ITitleImageAndText) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction='column'
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        gap: '24px',
        mb: '12px',
      }}
    >
      {showImage && (
        <Avatar
          alt=''
          src={image}
          sx={{
            width: '160px',
            height: '120px',
            ...imageSx,
          }}
        />
      )}
      <Typography variant={isDesktop ? 'h3' : 'h2'} component='h3'>
        {title}
      </Typography>
    </Stack>
  );
};
